import React, { Component } from 'react';
import { Table, Input, Button } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import { connect } from 'react-redux';

class AthKeycardAthlete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sportData: [],
            addSuccess: false,
            formData: {
                sport: "default",
                startDate: "",
                endDate: "",
                startTime: "",
                endTime: "",
                l1: false,
                l2: false,
                l3: false,
                l4: false,
                gym: false,
                volpe: false
            }
        }
        this.apiFetch("GetSportKeycards", {},"sportData")
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        this.setState({
            [stateItem]: data
        }, () => {
            if (url == "AddSportKeycard") {
                this.setState({
                    formData: {
                        sport: "default",
                        startDate: "",
                        endDate: "",
                        startTime: "",
                        endTime: "",
                        l1: false,
                        l2: false,
                        l3: false,
                        l4: false,
                        gym: false,
                        volpe: false
                    },
                    addSuccess: true
                })
                setTimeout(() => {
                    this.setState({
                        addSuccess: false
                    })
                }, 5000)
            }
        })
    }

    updateForm(field, val) {
        this.setState({
            formData: {...this.state.formData, [field]: val}
        })
    }

    render() {
        return (
            <div>
                <h2>Athlete</h2><br />
                <Table striped key={this.state.sportData}>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><Input type="select" name="sport" id="sport" value={this.state.formData.sport} onChange={(e) => this.updateForm("sport",e.target.value) }>
                                <option value="default" disabled>Sport</option>
                                {this.props.sportsList.map(item => (
                                    <option value={item.sportcode}>{item.sportname}</option>
                                    )) }
                            </Input>
                                <Button outline color="success" onClick={(e) => { e.preventDefault(); this.apiFetch("AddSportKeycard", this.state.formData, "sportData") }}>Add</Button>&nbsp;{this.state.addSuccess && <div>Success! <GoCheck /></div>}
                            </td>
                            <td><Input type="date" name="startdate" id="startdate" value={this.state.formData.startDate} onChange={(e) => this.updateForm("startDate",e.target.value)} />
                                Start Date</td>
                            <td><Input type="date" name="enddate" id="enddate" value={this.state.formData.endDate} onChange={(e) => this.updateForm("endDate",e.target.value)} />
                                End Date</td>
                            <td><Input type="time" name="starttime" id="starttime" value={this.state.formData.startTime} onChange={(e) => this.updateForm("startTime",e.target.value)} />
                                Start Time</td>
                            <td><Input type="time" name="endtime" id="endtime" value={this.state.formData.endTime} onChange={(e) => this.updateForm("endTime",e.target.value)} />
                                    End Time</td>
                            <td>
                                <Table>
                                    <tbody>
                                        <tr>
                                            <td><Input type="checkbox" name="checkA" id="checkA" checked={this.state.formData.l1} onClick={(e) => this.updateForm("a",e.target.checked)} /> L1</td>
                                            <td><Input type="checkbox" name="checkB" id="checkB" checked={this.state.formData.l2} onClick={(e) => this.updateForm("b",e.target.checked)} /> L2</td>
                                            <td><Input type="checkbox" name="checkC" id="checkC" checked={this.state.formData.gym} onClick={(e) => this.updateForm("e",e.target.checked) } /> Gym</td>
                                        </tr>
                                        <tr>
                                            <td><Input type="checkbox" name="checkD" id="checkD" checked={this.state.formData.l3} onClick={(e) => this.updateForm("c",e.target.checked) } /> L3</td>
                                            <td><Input type="checkbox" name="checkE" id="checkE" checked={this.state.formData.l4} onClick={(e) => this.updateForm("d",e.target.checked) } /> L4</td>
                                            <td><Input type="checkbox" name="checkF" id="checkF" checked={this.state.formData.volpe} onClick={(e) => this.updateForm("f",e.target.checked) } /> Volpe</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </td>
                        </tr>
                        {this.state.sportData.map(item => (
                            <tr>
                                <td>{item.sport}<br />
                                    <Button outline color="danger" onClick={(e) => this.apiFetch("DeleteSportKeycard", { targetpk: item.pk },"sportData") }>Delete</Button></td>
                                <td><Input type="date" name="startdate" id="startdate" defaultValue={item.startdate} onBlur={(e) => { if (e.target.value != item.startdate) this.apiFetch("UpdateSportKeycard", { targetpk: item.pk, field: "Start_Date", newvalue: e.target.value.toString() }, "sportData") }} />
                                    Start Date</td>
                                <td><Input type="date" name="enddate" id="enddate" defaultValue={item.enddate} onBlur={(e) => { if (e.target.value != item.enddate) this.apiFetch("UpdateSportKeycard", { field: "End_Date", targetpk: item.pk, newvalue: e.target.value.toString() }, "sportData") }} />
                                    End Date</td>
                                <td><Input type="time" name="starttime" id="starttime" defaultValue={item.starttime} onBlur={(e) => { if (e.target.value != item.starttime) this.apiFetch("UpdateSportKeycard", { field: "Start_Time", targetpk: item.pk, newvalue: e.target.value.toString() }, "sportData") }} />
                                    Start Time</td>
                                <td><Input type="time" name="endtime" id="endtime" defaultValue={item.endtime} onBlur={(e) => { if (e.target.value != item.endtime) this.apiFetch("UpdateSportKeycard", { field: "End_Time", targetpk: item.pk, newvalue: e.target.value.toString() },"sportData") }} />
                                    End Time</td>
                                <td>
                                    <Table>
                                        <tbody>
                                            <tr>
                                                <td><Input type="checkbox" name="L1box" id="L1box" checked={item.l1_a} onClick={(e) => this.apiFetch("UpdateSportKeycard", { field: "L1", targetpk: item.pk, newvalue: e.target.checked.toString() },"sportData")} />&nbsp;L1</td>
                                                <td><Input type="checkbox" name="L2box" id="L2box" checked={item.l2_b} onClick={(e) => this.apiFetch("UpdateSportKeycard", { field: "L2", targetpk: item.pk, newvalue: e.target.checked.toString() }, "sportData")} />&nbsp;L2</td>
                                                <td><Input type="checkbox" name="L3box" id="L3box" checked={item.gym_e} onClick={(e) => this.apiFetch("UpdateSportKeycard", { field: "Gym", targetpk: item.pk, newvalue: e.target.checked.toString() },"sportData")} />&nbsp;Gym</td>
                                            </tr>
                                            <tr>
                                                <td><Input type="checkbox" name="L4box" id="L4box" checked={item.l3_c} onClick={(e) => this.apiFetch("UpdateSportKeycard", { field: "L3", targetpk: item.pk, newvalue: e.target.checked.toString() }, "sportData")} />&nbsp;L3</td>
                                                <td><Input type="checkbox" name="gymbox" id="gymbox" checked={item.l4_d} onClick={(e) => this.apiFetch("UpdateSportKeycard", { field: "L4", targetpk: item.pk, newvalue: e.target.checked.toString() },"sportData")} />&nbsp;L4</td>
                                                <td><Input type="checkbox" name="volpebox" id="volpebox" checked={item.volpe_f} onClick={(e) => this.apiFetch("UpdateSportKeycard", { field: "Volpe", targetpk: item.pk, newvalue: e.target.checked.toString() },"sportData")} />&nbsp;Volpe</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                            </tr>
                            )) }
                    </tbody>
                </Table>
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(AthKeycardAthlete);